import { render, staticRenderFns } from "./insert_hotel.vue?vue&type=template&id=05d87bae&scoped=true"
import script from "./insert_hotel.vue?vue&type=script&lang=js"
export * from "./insert_hotel.vue?vue&type=script&lang=js"
import style0 from "./insert_hotel.vue?vue&type=style&index=0&id=05d87bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d87bae",
  null
  
)

export default component.exports